/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as WelcomeRouteImport } from "./routes/welcome"
import { Route as WaitlistRouteImport } from "./routes/waitlist"
import { Route as DevRouteImport } from "./routes/dev"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as AboutRouteImport } from "./routes/about"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as ProducerIndexRouteImport } from "./routes/producer/index"
import { Route as AuthIndexRouteImport } from "./routes/auth/index"
import { Route as TreatmentPatientIdRouteImport } from "./routes/treatment/$patientId"
import { Route as ProducerNewRouteImport } from "./routes/producer/new"
import { Route as ProducerProducerIdRouteImport } from "./routes/producer/$producerId"
import { Route as PrescriptionPatientIdRouteImport } from "./routes/prescription/$patientId"
import { Route as PatientAddressRouteImport } from "./routes/patient/address"
import { Route as PatientPatientIdRouteImport } from "./routes/patient/$patientId"
import { Route as IntakePatientIdRouteImport } from "./routes/intake/$patientId"
import { Route as AuthLogoutRouteImport } from "./routes/auth/logout"
import { Route as AuthAdminRouteImport } from "./routes/auth/admin"
import { Route as AuthAccountRouteImport } from "./routes/auth/account"

const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: "/waitlist",
  path: "/waitlist",
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: "/dev",
  path: "/dev",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerIndexRoute = ProducerIndexRouteImport.update({
  id: "/producer/",
  path: "/producer/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: "/auth/",
  path: "/auth/",
  getParentRoute: () => rootRouteImport,
} as any)
const TreatmentPatientIdRoute = TreatmentPatientIdRouteImport.update({
  id: "/treatment/$patientId",
  path: "/treatment/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerNewRoute = ProducerNewRouteImport.update({
  id: "/producer/new",
  path: "/producer/new",
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerProducerIdRoute = ProducerProducerIdRouteImport.update({
  id: "/producer/$producerId",
  path: "/producer/$producerId",
  getParentRoute: () => rootRouteImport,
} as any)
const PrescriptionPatientIdRoute = PrescriptionPatientIdRouteImport.update({
  id: "/prescription/$patientId",
  path: "/prescription/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientAddressRoute = PatientAddressRouteImport.update({
  id: "/patient/address",
  path: "/patient/address",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientPatientIdRoute = PatientPatientIdRouteImport.update({
  id: "/patient/$patientId",
  path: "/patient/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const IntakePatientIdRoute = IntakePatientIdRouteImport.update({
  id: "/intake/$patientId",
  path: "/intake/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: "/auth/logout",
  path: "/auth/logout",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: "/auth/admin",
  path: "/auth/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: "/auth/account",
  path: "/auth/account",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/intake/$patientId": typeof IntakePatientIdRoute
  "/patient/$patientId": typeof PatientPatientIdRoute
  "/patient/address": typeof PatientAddressRoute
  "/prescription/$patientId": typeof PrescriptionPatientIdRoute
  "/producer/$producerId": typeof ProducerProducerIdRoute
  "/producer/new": typeof ProducerNewRoute
  "/treatment/$patientId": typeof TreatmentPatientIdRoute
  "/auth/": typeof AuthIndexRoute
  "/producer/": typeof ProducerIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/intake/$patientId": typeof IntakePatientIdRoute
  "/patient/$patientId": typeof PatientPatientIdRoute
  "/patient/address": typeof PatientAddressRoute
  "/prescription/$patientId": typeof PrescriptionPatientIdRoute
  "/producer/$producerId": typeof ProducerProducerIdRoute
  "/producer/new": typeof ProducerNewRoute
  "/treatment/$patientId": typeof TreatmentPatientIdRoute
  "/auth": typeof AuthIndexRoute
  "/producer": typeof ProducerIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/intake/$patientId": typeof IntakePatientIdRoute
  "/patient/$patientId": typeof PatientPatientIdRoute
  "/patient/address": typeof PatientAddressRoute
  "/prescription/$patientId": typeof PrescriptionPatientIdRoute
  "/producer/$producerId": typeof ProducerProducerIdRoute
  "/producer/new": typeof ProducerNewRoute
  "/treatment/$patientId": typeof TreatmentPatientIdRoute
  "/auth/": typeof AuthIndexRoute
  "/producer/": typeof ProducerIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/waitlist"
    | "/welcome"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/logout"
    | "/intake/$patientId"
    | "/patient/$patientId"
    | "/patient/address"
    | "/prescription/$patientId"
    | "/producer/$producerId"
    | "/producer/new"
    | "/treatment/$patientId"
    | "/auth/"
    | "/producer/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/waitlist"
    | "/welcome"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/logout"
    | "/intake/$patientId"
    | "/patient/$patientId"
    | "/patient/address"
    | "/prescription/$patientId"
    | "/producer/$producerId"
    | "/producer/new"
    | "/treatment/$patientId"
    | "/auth"
    | "/producer"
  id:
    | "__root__"
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/waitlist"
    | "/welcome"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/logout"
    | "/intake/$patientId"
    | "/patient/$patientId"
    | "/patient/address"
    | "/prescription/$patientId"
    | "/producer/$producerId"
    | "/producer/new"
    | "/treatment/$patientId"
    | "/auth/"
    | "/producer/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DashboardRoute: typeof DashboardRoute
  DevRoute: typeof DevRoute
  WaitlistRoute: typeof WaitlistRoute
  WelcomeRoute: typeof WelcomeRoute
  AuthAccountRoute: typeof AuthAccountRoute
  AuthAdminRoute: typeof AuthAdminRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  IntakePatientIdRoute: typeof IntakePatientIdRoute
  PatientPatientIdRoute: typeof PatientPatientIdRoute
  PatientAddressRoute: typeof PatientAddressRoute
  PrescriptionPatientIdRoute: typeof PrescriptionPatientIdRoute
  ProducerProducerIdRoute: typeof ProducerProducerIdRoute
  ProducerNewRoute: typeof ProducerNewRoute
  TreatmentPatientIdRoute: typeof TreatmentPatientIdRoute
  AuthIndexRoute: typeof AuthIndexRoute
  ProducerIndexRoute: typeof ProducerIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/welcome": {
      id: "/welcome"
      path: "/welcome"
      fullPath: "/welcome"
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/waitlist": {
      id: "/waitlist"
      path: "/waitlist"
      fullPath: "/waitlist"
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev": {
      id: "/dev"
      path: "/dev"
      fullPath: "/dev"
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/about": {
      id: "/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/producer/": {
      id: "/producer/"
      path: "/producer"
      fullPath: "/producer/"
      preLoaderRoute: typeof ProducerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/": {
      id: "/auth/"
      path: "/auth"
      fullPath: "/auth/"
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/treatment/$patientId": {
      id: "/treatment/$patientId"
      path: "/treatment/$patientId"
      fullPath: "/treatment/$patientId"
      preLoaderRoute: typeof TreatmentPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/producer/new": {
      id: "/producer/new"
      path: "/producer/new"
      fullPath: "/producer/new"
      preLoaderRoute: typeof ProducerNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/producer/$producerId": {
      id: "/producer/$producerId"
      path: "/producer/$producerId"
      fullPath: "/producer/$producerId"
      preLoaderRoute: typeof ProducerProducerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/prescription/$patientId": {
      id: "/prescription/$patientId"
      path: "/prescription/$patientId"
      fullPath: "/prescription/$patientId"
      preLoaderRoute: typeof PrescriptionPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/address": {
      id: "/patient/address"
      path: "/patient/address"
      fullPath: "/patient/address"
      preLoaderRoute: typeof PatientAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/$patientId": {
      id: "/patient/$patientId"
      path: "/patient/$patientId"
      fullPath: "/patient/$patientId"
      preLoaderRoute: typeof PatientPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/intake/$patientId": {
      id: "/intake/$patientId"
      path: "/intake/$patientId"
      fullPath: "/intake/$patientId"
      preLoaderRoute: typeof IntakePatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/logout": {
      id: "/auth/logout"
      path: "/auth/logout"
      fullPath: "/auth/logout"
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/admin": {
      id: "/auth/admin"
      path: "/auth/admin"
      fullPath: "/auth/admin"
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/account": {
      id: "/auth/account"
      path: "/auth/account"
      fullPath: "/auth/account"
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DashboardRoute: DashboardRoute,
  DevRoute: DevRoute,
  WaitlistRoute: WaitlistRoute,
  WelcomeRoute: WelcomeRoute,
  AuthAccountRoute: AuthAccountRoute,
  AuthAdminRoute: AuthAdminRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  IntakePatientIdRoute: IntakePatientIdRoute,
  PatientPatientIdRoute: PatientPatientIdRoute,
  PatientAddressRoute: PatientAddressRoute,
  PrescriptionPatientIdRoute: PrescriptionPatientIdRoute,
  ProducerProducerIdRoute: ProducerProducerIdRoute,
  ProducerNewRoute: ProducerNewRoute,
  TreatmentPatientIdRoute: TreatmentPatientIdRoute,
  AuthIndexRoute: AuthIndexRoute,
  ProducerIndexRoute: ProducerIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
